import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import React from 'react';
import { AutomatedNotificationService } from '../../../Component/Api/AutomatedNotifications/AutomatedNotificationService';
import { AutomatedNotificationRuleDataRow, NotificationRuleSearchRequest } from '../../../Component/Model/Dto/AutomatedNotification/AutomatedNotificationRule';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { AutomatedNotificationRulesTableMapper } from './AutomatedNotificationRulesTableMapper';
import { toast } from 'react-toastify';
import { ConfirmationDialog } from '../../../Component/Common/Components/ConfirmationDialog';
import { AutomatedNotificationModal } from './AutomatedNotificationModal';
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import { MDBox } from '../../../Component/Common/Components/MDBox';
import { MDTypography } from '../../../Component/Common/Components/MDTypography';

export const AutomatedNotificationsPage = () => {

    const [AutomatedNotificationRuleData, setAutomatedNotificationRuleData] = React.useState<AutomatedNotificationRuleDataRow[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [searchValue, setSearchValue] = useState<string>('');
    const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);
    const confirmDeleteMessage = "Are you sure you want to delete this notification?";
    const [selectedNotificationId, setSelectedNotificationId] = useState<number>(0);
    const [showNotificationModal, setShowNotificationModal] = useState(false);

    useEffect(() => {
        searchNotificationRules();
    }, [searchValue, entriesPerPage, pageNumber]);

    const searchRequest: NotificationRuleSearchRequest = {
        Draw: 2,
        PageNumber: pageNumber,
        PageSize: entriesPerPage.defaultValue!,
        SearchValue: searchValue,
    }

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const handleCloseConfirmation = () => {
        setShowConfirmationDialog(false);
        setSelectedNotificationId(0);
    }

    const showDeleteConfirmation = (id: number) => {
        setShowConfirmationDialog(true);
        setSelectedNotificationId(id);
    }

    const handleEditNotification = (id: number) => {
        setSelectedNotificationId(id);
        setShowNotificationModal(true);
    }

    const handleCloseNotification = () => {
        setSelectedNotificationId(0);
        searchNotificationRules();
        setShowNotificationModal(false);
    }

    const handleDelete = async () => {
        try {
            await AutomatedNotificationService.DeleteAutomatedNotificationRule(selectedNotificationId);
            toast.success("Successfully deleted notification");
            searchNotificationRules();
        } catch (error) {
            console.log(error)
        } finally {
            handleCloseConfirmation();
        }
    }

    const searchValueChanged = (searchValue: string) => {
        setSearchValue(searchValue);
    }

    const searchNotificationRules = async () => {
        setIsLoading(true);
        try {
            const notificationsReponse = await AutomatedNotificationService.SearchNotificationRules(searchRequest);
            setAutomatedNotificationRuleData(notificationsReponse.data.results);
            setFilteredItemsCount(notificationsReponse.data.filteredItemsCount)
            setTotalItemsCount(notificationsReponse.data.totalItemsCount)
        } catch (error) { }
        finally {
            setIsLoading(false);
        }
    }

    const handleAddApplication = () => {
        setShowNotificationModal(true);
    }

    const bulkActions = [
        {
            label: "Add Notification",
            action: handleAddApplication
        }
    ]

    const tableData = AutomatedNotificationRulesTableMapper(AutomatedNotificationRuleData, showDeleteConfirmation, handleEditNotification);

    return (
        <div className='center'>
            <Grid container>
                <Grid item xs={12}>
                    <DataTable
                        key={totalItemsCount}
                        table={tableData}
                        canSearch
                        entriesPerPage={entriesPerPage}
                        pageNumber={pageNumber}
                        filteredItemsCount={filteredItemsCount}
                        totalItemsCount={totalItemsCount}
                        entriesPerPageChanged={entriesPerPageChanged}
                        pageNumberChanged={pageNumberChanged}
                        searchValueChanged={searchValueChanged}
                        isLoading={isLoading}
                        bulkActions={bulkActions}
                        manualSorting={false}
                    ></DataTable>

                    <ConfirmationDialog
                        showDialog={showConfirmationDialog}
                        handleAccept={handleDelete}
                        handleCancel={handleCloseConfirmation}
                        heading={"Confirm Delete"}
                        message={confirmDeleteMessage}
                    />
                    {showNotificationModal && <AutomatedNotificationModal id={selectedNotificationId} handleClose={handleCloseNotification} showModal={showNotificationModal} />}
                </Grid>
            </Grid>
        </div>
    )
}